import React, { FC } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import css from './styles.module.scss';

interface IInfoLineProps {
  text: string;
  color?: string;
}

const InfoLine: FC<IInfoLineProps> = ({ text, color = '#000' }) => (
    <div className={css.info}>
      <FiAlertCircle size={16} color={color} className="warning-icon" />
      <span>{text}</span>
    </div>
  );

export default InfoLine;
